export const DemographicIcon: React.FC = () => (
  <svg width='44' height='44' viewBox='0 0 44 44' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M16.668 7.33333C16.668 8.74782 17.2299 10.1044 18.2301 11.1046C19.2303 12.1048 20.5868 12.6667 22.0013 12.6667C23.4158 12.6667 24.7723 12.1048 25.7725 11.1046C26.7727 10.1044 27.3346 8.74782 27.3346 7.33333C27.3346 5.91885 26.7727 4.56229 25.7725 3.5621C24.7723 2.5619 23.4158 2 22.0013 2C20.5868 2 19.2303 2.5619 18.2301 3.5621C17.2299 4.56229 16.668 5.91885 16.668 7.33333V7.33333Z'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M28.6673 26.0007V22.0007C28.6673 20.2325 27.9649 18.5368 26.7147 17.2866C25.4645 16.0364 23.7688 15.334 22.0007 15.334C20.2325 15.334 18.5368 16.0364 17.2866 17.2866C16.0364 18.5368 15.334 20.2325 15.334 22.0007V26.0007H18.0007L19.334 36.6673H24.6673L26.0007 26.0007H28.6673Z'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M4.66602 11.334C4.66602 12.3949 5.08744 13.4123 5.83759 14.1624C6.58773 14.9126 7.60515 15.334 8.66602 15.334C9.72688 15.334 10.7443 14.9126 11.4944 14.1624C12.2446 13.4123 12.666 12.3949 12.666 11.334C12.666 10.2731 12.2446 9.2557 11.4944 8.50556C10.7443 7.75541 9.72688 7.33398 8.66602 7.33398C7.60515 7.33398 6.58773 7.75541 5.83759 8.50556C5.08744 9.2557 4.66602 10.2731 4.66602 11.334V11.334Z'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.8 18.3504C9.79706 18.0129 8.72822 17.9188 7.68174 18.0759C6.63525 18.2329 5.64113 18.6366 4.78145 19.2537C3.92178 19.8707 3.2212 20.6834 2.73757 21.6247C2.25394 22.5659 2.00113 23.6086 2 24.6669V26.0002H4.66667L6 34.0002H11.3333L12.0018 29.9895'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M31.332 11.334C31.332 12.3949 31.7535 13.4123 32.5036 14.1624C33.2537 14.9126 34.2712 15.334 35.332 15.334C36.3929 15.334 37.4103 14.9126 38.1605 14.1624C38.9106 13.4123 39.332 12.3949 39.332 11.334C39.332 10.2731 38.9106 9.2557 38.1605 8.50556C37.4103 7.75541 36.3929 7.33398 35.332 7.33398C34.2712 7.33398 33.2537 7.75541 32.5036 8.50556C31.7535 9.2557 31.332 10.2731 31.332 11.334Z'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M33.2018 18.3504C34.2047 18.0129 35.2736 17.9188 36.32 18.0759C37.3665 18.2329 38.3606 18.6366 39.2203 19.2537C40.08 19.8707 40.7806 20.6834 41.2642 21.6247C41.7478 22.5659 42.0007 23.6086 42.0018 24.6669V26.0002H39.3351L38.0018 34.0002H32.6684L32 29.9895'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M42 38C42 40.2098 33.0453 42 22 42C10.9547 42 2 40.2098 2 38'
      stroke='#1F74B6'
      strokeWidth='2.25'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
)
